import {
  fetchProductsAPI,
  fetchProductByIdAPI,
  createProductAPI,
  deleteProductAPI,
  updateProductAPI,
  fetchProductsByCategorySlugAPI,
} from "./api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setErrorAlert, setSuccessAlert } from "containers/Toast/slice";

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (
    {
      pageConfig = {
        page: 1,
      },
    },
    { rejectWithValue }
  ) => {
    try {
      return await fetchProductsAPI(pageConfig);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchProductsByCategorySlug = createAsyncThunk(
  "products/fetchProductsByCategorySlug",
  async (
    {
      categorySlug,
      pageConfig = {
        page: 1,
      },
    },
    { rejectWithValue }
  ) => {
    try {
      return await fetchProductsByCategorySlugAPI(categorySlug, pageConfig);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchProductById = createAsyncThunk(
  "products/fetchProductById",
  async (id, { rejectWithValue }) => {
    try {
      return await fetchProductByIdAPI(id);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createProduct = createAsyncThunk(
  "products/createProduct",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await createProductAPI(data);
      dispatch(setSuccessAlert("Product created successfully!"));
      return response;
    } catch (error) {
      dispatch(setErrorAlert(`Failed to create product`));
      return rejectWithValue(error.message);
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "products/deleteProduct",
  async ({ id }, { rejectWithValue, dispatch }) => {
    try {
      const response = await deleteProductAPI(id);
      dispatch(setSuccessAlert("Product deleted successfully!"));
      return response;
    } catch (error) {
      dispatch(setErrorAlert(`Failed to delete product`));
      return rejectWithValue(error.message);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "products/updateProduct",
  async ({ product, id }, { rejectWithValue, dispatch }) => {
    try {
      const response = await updateProductAPI(id, product);
      dispatch(setSuccessAlert("Product updated successfully!"));
      return response;
    } catch (error) {
      dispatch(setErrorAlert(`Failed to update product`));
      return rejectWithValue(error.message);
    }
  }
);
